import { erroPeriodoConsulta } from '../../../core/tools/periodo-consulta';
import { Component, OnInit } from '@angular/core';
import { Animacao } from '../../../core/tools/animacao';
import {
  DashboardPromocao,
  DashboardPromocaoProduto,
  DashboardPromocoesService
} from '../../../core/services/dashboard/promocoes/dashboard-promocoes.service';

@Component({
  selector: 'app-dashboard-promocoes',
  templateUrl: './dashboard-promocoes.component.html',
  styleUrls: ['./dashboard-promocoes.component.css'],
  preserveWhitespaces: false,
  animations: [Animacao],
  standalone: false
})
export class DashboardPromocoesComponent implements OnInit {
  erroPeriodo = '';
  carregando: boolean = false;
  dataInicio: string;
  dataFim: string;
  tipoDados: 'FATURADO' | 'GERAL' = 'FATURADO';
  promocaoFiltro: string = '';
  abaAtiva: 'promocao' | 'tabela' = 'promocao';
  ordenacao: 'valor' | 'quantidade' | 'litros' | 'pedidos' = 'valor';
  promocaoVendedoresAberta: number = null;
  promocaoProdutosAberta: number = null;
  produtoAberto: number = null;

  promocoes: DashboardPromocao[] = [];
  produtos: DashboardPromocaoProduto[] = [];

  constructor(private dashboardPromocoesService: DashboardPromocoesService) {
    const hoje = new Date();
    this.dataInicio = this.formatarDataApi(new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - 6));
    this.dataFim = this.formatarDataApi(hoje);
  }

  ngOnInit() {
    this.atualizar();
  }

  atualizar() {
    this.erroPeriodo = erroPeriodoConsulta(this.dataInicio, this.dataFim);
    if (this.erroPeriodo) return;

    this.carregando = true;

    this.dashboardPromocoesService.getResumo({
      userId: parseInt(localStorage.getItem('id')),
      dataInicio: this.dataInicio,
      dataFim: this.dataFim,
      tipoDados: this.tipoDados
    }).subscribe(resumo => {
      this.promocoes = resumo.promocoes || [];
      this.produtos = resumo.produtos || [];
      this.carregando = false;
    }, () => {
      this.carregando = false;
    });
  }

  alternarVendedoresPromocao(promocao: DashboardPromocao) {
    this.promocaoVendedoresAberta = this.promocaoVendedoresAberta == promocao.promocaoId ? null : promocao.promocaoId;

    if (this.promocaoVendedoresAberta != null) {
      this.promocaoProdutosAberta = null;
      this.produtoAberto = null;
    }
  }

  alternarProdutosPromocao(promocao: DashboardPromocao) {
    this.promocaoProdutosAberta = this.promocaoProdutosAberta == promocao.promocaoId ? null : promocao.promocaoId;

    if (this.promocaoProdutosAberta != null) {
      this.promocaoVendedoresAberta = null;
      this.produtoAberto = null;
    }
  }

  alternarProduto(produto: DashboardPromocaoProduto) {
    this.produtoAberto = this.produtoAberto == produto.produtoEspecialId ? null : produto.produtoEspecialId;
  }

  promocoesFiltradas(): DashboardPromocao[] {
    const termo = this.normalizar(this.promocaoFiltro);

    return this.promocoes
      .filter(item => this.abaAtiva == 'tabela' ? item.flagNaoAplicaFatorPontuacaoFin : !item.flagNaoAplicaFatorPontuacaoFin)
      .filter(item => termo == '' || this.normalizar(item.promocao).indexOf(termo) > -1)
      .sort((a, b) => this.compararOrdenacao(b, a));
  }

  totalPromocoesAba(): number {
    return this.promocoes.filter(item => !item.flagNaoAplicaFatorPontuacaoFin).length;
  }

  totalTabelasAba(): number {
    return this.promocoes.filter(item => item.flagNaoAplicaFatorPontuacaoFin).length;
  }

  alterarAba(aba: 'promocao' | 'tabela') {
    this.abaAtiva = aba;
    this.promocaoVendedoresAberta = null;
    this.promocaoProdutosAberta = null;
    this.produtoAberto = null;
  }

  produtosDaPromocao(promocaoId: number): DashboardPromocaoProduto[] {
    return this.produtos
      .filter(item => item.promocaoId == promocaoId)
      .sort((a, b) => this.compararOrdenacao(b, a));
  }

  resumoValor(valor: number): string {
    return (valor || 0).toLocaleString('pt-BR', { maximumFractionDigits: 0 });
  }

  totalPromocoesUsadasAba(): number {
    return this.promocoesDaAba().filter(item => (item.vendasReais || 0) != 0 || (item.quantidade || 0) != 0 || (item.litros || 0) != 0).length;
  }

  totalProdutosUsadosAba(): number {
    const idsPromocoes = this.promocoesDaAba().map(item => item.promocaoId);

    return this.produtos
      .filter(item => idsPromocoes.indexOf(item.promocaoId) > -1)
      .filter(item => (item.quantidade || 0) != 0)
      .length;
  }

  totalVendasReaisAba(): number {
    return this.promocoesDaAba().reduce((sum, item) => sum + (item.vendasReais || 0), 0);
  }

  totalQuantidadeAba(): number {
    return this.promocoesDaAba().reduce((sum, item) => sum + (item.quantidade || 0), 0);
  }

  totalLitrosAba(): number {
    return this.promocoesDaAba().reduce((sum, item) => sum + (item.litros || 0), 0);
  }

  totalPedidosAba(): number {
    return this.promocoesDaAba().reduce((sum, item) => sum + (item.pedidos || 0), 0);
  }

  private promocoesDaAba(): DashboardPromocao[] {
    return this.promocoes.filter(item => this.abaAtiva == 'tabela' ? item.flagNaoAplicaFatorPontuacaoFin : !item.flagNaoAplicaFatorPontuacaoFin);
  }

  private compararOrdenacao(a: { vendasReais: number, quantidade: number, litros: number, pedidos: number }, b: { vendasReais: number, quantidade: number, litros: number, pedidos: number }): number {
    switch (this.ordenacao) {
      case 'quantidade':
        return (a.quantidade || 0) - (b.quantidade || 0) || (a.vendasReais || 0) - (b.vendasReais || 0);
      case 'litros':
        return (a.litros || 0) - (b.litros || 0) || (a.vendasReais || 0) - (b.vendasReais || 0);
      case 'pedidos':
        return (a.pedidos || 0) - (b.pedidos || 0) || (a.vendasReais || 0) - (b.vendasReais || 0);
      default:
        return (a.vendasReais || 0) - (b.vendasReais || 0) || (a.quantidade || 0) - (b.quantidade || 0);
    }
  }

  private normalizar(valor: string): string {
    return (valor || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  private formatarDataApi(data: Date): string {
    const ano = data.getFullYear();
    const mes = (data.getMonth() + 1).toString().padStart(2, '0');
    const dia = data.getDate().toString().padStart(2, '0');

    return `${ano}-${mes}-${dia}`;
  }
}
